import { useMemo } from 'react';
import adminIcon from '@/assets/images/home/adminIcon.png'
import { ChevronRight } from 'lucide-react';
import { useTeamContext } from '@/hooks/useTeamContext';
import { USER_ROLES } from '@/config/permissions';
export default function AdminBanner() { 
  const { user } = useTeamContext();
  const companyName = useMemo(() => { 
    if(!user) return '';
    return user?.company_name;
  }, [user]);

  const paenlText = useMemo(() => { 
    if(!user) return '';
    return user?.role === USER_ROLES.FREELANCER ? 'freelancer panel' : ' admin panel';
  }, [user]);


  const onBackoffice = () => {
    // Utiliser une variable d'environnement pour l'URL du backoffice admin
    // Si non définie, désactiver la redirection (migration vers Next.js en cours)
    const adminBackofficeUrl = import.meta.env.VITE_ADMIN_BACKOFFICE_URL;
    
    if (!adminBackofficeUrl) {
      console.warn('[AdminBanner] VITE_ADMIN_BACKOFFICE_URL not configured. Backoffice redirection disabled.');
      return;
    }
    
    if(user?.role === USER_ROLES.FREELANCER) {
      window.location.href = `${adminBackofficeUrl}/app/freelancers`;
    } else {
      window.location.href = `${adminBackofficeUrl}/app/companies`;
    }
  }

  return (
    <div className="bg-[#173331] w-full h-[50px] flex justify-between items-center text-white px-5">
      <div className="flex items-center">
        <img src={adminIcon} alt="" className="mr-[10px]" />
        <span>You are currently logged in as System Admin in the company <span className="font-bold text-(--app-warning-color)">{companyName}</span> {paenlText}.</span>
      </div>
      <div className="cursor-pointer transition-all duration-300 ease-in-out flex items-center hover:text-(--app-warning-color)" onClick={onBackoffice}>
        <span className="admin-banner-btn-text">
          Go to Backoffice
        </span>
        <ChevronRight className="ml-1 h-4 w-4" />
      
      </div>
    </div>
  )
}
